import { signIn, useSession } from 'next-auth/react'
import { useRequest } from 'ahooks'
import { sigV1 } from '@loc/helpers/src/sig/main'
import { useLingui } from '@lingui/react/macro'

import { useAfterLogin } from './afterLogin'
import { useTrackSignInOrSignUp } from './trackSignInOrSignUp'

import { useAntdContext } from '@/contexts/AntdContext/hooks'

export interface ISignInInitialValue {}

export function useSignIn(initialValue?: ISignInInitialValue) {
  const { message } = useAntdContext()
  const { t } = useLingui()
  const { afterLogin } = useAfterLogin()
  const session = useSession()
  const { setAuthMethod, setOriginUrlState } = useTrackSignInOrSignUp({
    enabled: false,
  })

  const handleSignIn: typeof signIn = (...params) => {
    setOriginUrlState(window.location.href)
    return signIn(...params)
  }

  const result = useRequest(handleSignIn, {
    manual: true,
    onSuccess: (data, params) => {
      // 可能第三方都不会返回 data
      if (params[0] === 'google') {
        setAuthMethod('Google')

        afterLogin()
        return
      }
      if (!data?.ok) {
        message.error(data?.error || t`Something wrong! Try again.`)
      } else {
        setAuthMethod('email')
        session.update()
        afterLogin()
      }
    },
    onError: (error) => {
      // consola.log(error, 'error')
      message.error(error?.message || t`Something wrong! Try again.`)
    },
  })

  const postSignUpEmail = async (email: string) => {
    return await result.runAsync('email', {
      email,
      redirect: false,
    })
  }

  const run: typeof result.run = async (
    provider,
    options,
    authorizationParams,
  ) => {
    const mergedOptions =
      provider === 'system-user'
        ? { ...(await sigV1((options?.password as string) || '')), ...options }
        : options
    result.run(provider, mergedOptions, authorizationParams)
  }
  const runAsync: typeof result.runAsync = async (
    provider,
    options,
    authorizationParams,
  ) => {
    const mergedOptions =
      provider === 'system-user'
        ? { ...(await sigV1((options?.password as string) || '')), ...options }
        : options
    return result.runAsync(provider, mergedOptions, authorizationParams)
  }

  return { ...result, postSignUpEmail, run, runAsync }
}
